module.exports = __webpack_public_path__ + "img/02.8a98fa09.png";